import { CSAT_DISPLAY_TYPES } from 'shared/constants/messages';

export const CSAT_QUESTION_TYPES = {
  STARS: 'stars',
  THUMBS: 'thumbs',
  EMOJI5: 'emoji5',
  EMOJI3: 'emoji3',
  NPS: 'nps',
  COMMENT: 'comment',
  CHOICE: 'choice',
};

export const LEGACY_RATING_QUESTION_ID = 'legacy_rating';
export const LEGACY_COMMENT_QUESTION_ID = 'legacy_feedback';

export const CSAT_RATING_TYPES = [
  CSAT_QUESTION_TYPES.STARS,
  CSAT_QUESTION_TYPES.THUMBS,
  CSAT_QUESTION_TYPES.EMOJI5,
  CSAT_QUESTION_TYPES.EMOJI3,
  CSAT_QUESTION_TYPES.NPS,
  CSAT_QUESTION_TYPES.CHOICE,
];

export const EMOJI5_OPTIONS = [
  { value: 1, emoji: '😞' },
  { value: 2, emoji: '😑' },
  { value: 3, emoji: '😐' },
  { value: 4, emoji: '😀' },
  { value: 5, emoji: '😍' },
];

export const EMOJI3_OPTIONS = [
  { value: 1, emoji: '😞' },
  { value: 2, emoji: '😐' },
  { value: 3, emoji: '😍' },
];

export const THUMBS_OPTIONS = [
  { value: 0, iconClass: 'i-lucide-thumbs-down', colorClass: 'text-n-ruby-9' },
  { value: 1, iconClass: 'i-lucide-thumbs-up', colorClass: 'text-green-600' },
];

export const NPS_OPTIONS = Array.from({ length: 11 }, (_, index) => ({
  value: index,
}));

export const isCsatRatingType = type => CSAT_RATING_TYPES.includes(type);

export const isNegativeRatingAnswer = (question, value) => {
  if (!question || !isCsatRatingType(question.type)) return false;
  if (value === null || value === undefined || value === '') return false;

  if (question.type === CSAT_QUESTION_TYPES.CHOICE) {
    const opt = (question.options || []).find(
      o => (typeof o === 'string' ? o : o.text) === value
    );
    if (!opt) return false;
    return (typeof opt === 'string' ? null : opt.positive) === false;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return false;
  const threshold = Number(question.threshold);
  if (!Number.isFinite(threshold)) return false;
  return numericValue < threshold;
};

export const normalizeRatingValue = (type, value, question = null) => {
  if (type === CSAT_QUESTION_TYPES.CHOICE) {
    if (!value || !question?.options) return null;
    const opt = question.options.find(
      o => (typeof o === 'string' ? o : o.text) === value
    );
    if (!opt) return null;
    const isPositive = typeof opt === 'string' ? null : opt.positive;
    if (isPositive === true) return 5;
    if (isPositive === false) return 1;
    return null;
  }

  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;

  const clampToScale = number => Math.min(5, Math.max(1, Math.round(number)));

  switch (type) {
    case CSAT_QUESTION_TYPES.EMOJI3:
      return { 1: 1, 2: 3, 3: 5 }[numeric] ?? null;
    case CSAT_QUESTION_TYPES.THUMBS:
      return numeric > 0 ? 5 : 1;
    case CSAT_QUESTION_TYPES.NPS:
      if (numeric >= 9) return 5;
      if (numeric >= 7) return 3;
      return 1;
    default:
      return clampToScale(numeric);
  }
};

export const buildLegacyQuestions = (
  displayType,
  { commentPlaceholder } = {}
) => [
  {
    id: LEGACY_RATING_QUESTION_ID,
    type:
      displayType === CSAT_DISPLAY_TYPES.STAR
        ? CSAT_QUESTION_TYPES.STARS
        : CSAT_QUESTION_TYPES.EMOJI5,
    text: '',
    required: true,
    enabled: true,
  },
  {
    id: LEGACY_COMMENT_QUESTION_ID,
    type: CSAT_QUESTION_TYPES.COMMENT,
    text: '',
    required: false,
    enabled: true,
    placeholder: commentPlaceholder || '',
  },
];
